var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgGoodJob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 202.358,
    height: 212.812,
    viewBox: "0 0 202.358 212.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1136",
    "data-name": "Rectangle 1136",
    width: 202.358,
    height: 212.812,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_good_job",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(0 -0.002)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21978",
    "data-name": "Path 21978",
    d: "M202.358,172.971A101.179,101.179,0,1,1,101.179,71.792,101.179,101.179,0,0,1,202.358,172.971",
    transform: "translate(0 -61.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21979",
    "data-name": "Path 21979",
    d: "M383.372,219.93H274.387a7.881,7.881,0,0,1-7.881-7.881V69.738a7.881,7.881,0,0,1,7.881-7.881H383.372a7.881,7.881,0,0,1,7.881,7.881V212.049a7.881,7.881,0,0,1-7.881,7.881",
    transform: "translate(-227.701 -52.85)",
    fill: "#49a8fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21980",
    "data-name": "Path 21980",
    d: "M788.918,980.684h21.931l-16.93-16.93Z",
    transform: "translate(-674.046 -823.424)",
    fill: "#8ca6c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21981",
    "data-name": "Path 21981",
    d: "M439.052,129.3V250.8a16.93,16.93,0,1,1-33.86,0V231.464H333.943V129.3Z",
    transform: "translate(-285.318 -110.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1135",
    "data-name": "Rectangle 1135",
    width: 71.249,
    height: 38.266,
    transform: "translate(48.625 118.994)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21982",
    "data-name": "Path 21982",
    d: "M651.03,9.005A9.007,9.007,0,1,1,642.023,0a9.007,9.007,0,0,1,9.007,9.007",
    transform: "translate(-540.844 0.002)",
    fill: "#49a8fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21983",
    "data-name": "Path 21983",
    d: "M540.538,125.861H498.691a8.944,8.944,0,0,1-8.945-8.944h59.736a8.944,8.944,0,0,1-8.945,8.944",
    transform: "translate(-418.435 -99.893)",
    fill: "#49a8fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21984",
    "data-name": "Path 21984",
    d: "M222.519,892.818v27.259h-85.45a16.93,16.93,0,0,1-16.93-16.93V892.818Z",
    transform: "translate(-102.646 -762.817)",
    fill: "#8ca6c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21985",
    "data-name": "Path 21985",
    d: "M535.472,349.626a32.746,32.746,0,1,1-32.746-32.746,32.746,32.746,0,0,1,32.746,32.746",
    transform: "translate(-401.547 -270.74)",
    fill: "#73f781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21986",
    "data-name": "Path 21986",
    d: "M565.706,467.441a3.916,3.916,0,0,1-2.778-1.15l-11.6-11.6a3.928,3.928,0,1,1,5.555-5.555l8.818,8.818,19.907-19.907a3.928,3.928,0,0,1,5.555,5.555l-22.685,22.685a3.916,3.916,0,0,1-2.777,1.15",
    transform: "translate(-470.072 -373.284)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21987",
    "data-name": "Path 21987",
    d: "M117.838,205.953l5.906-1.756-5.906-1.756a8.623,8.623,0,0,1-5.808-5.808l-1.756-5.906-1.756,5.906a8.624,8.624,0,0,1-5.808,5.808L96.8,204.2l5.906,1.756a8.624,8.624,0,0,1,5.808,5.808l1.756,5.906,1.756-5.906a8.623,8.623,0,0,1,5.808-5.808",
    transform: "translate(-82.709 -162.955)",
    fill: "#8ca6c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21988",
    "data-name": "Path 21988",
    d: "M368.069,386.467l2.542-.756-2.542-.756a3.712,3.712,0,0,1-2.5-2.5l-.756-2.542-.756,2.542a3.712,3.712,0,0,1-2.5,2.5l-2.542.756,2.542.756a3.712,3.712,0,0,1,2.5,2.5l.756,2.542.756-2.542a3.712,3.712,0,0,1,2.5-2.5",
    transform: "translate(-306.74 -324.594)",
    fill: "#8ca6c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21989",
    "data-name": "Path 21989",
    d: "M928.821,258.4l2.542-.756-2.542-.756a3.712,3.712,0,0,1-2.5-2.5l-.756-2.542-.756,2.542a3.712,3.712,0,0,1-2.5,2.5l-2.542.756,2.542.756a3.712,3.712,0,0,1,2.5,2.5l.756,2.542.756-2.542a3.712,3.712,0,0,1,2.5-2.5",
    transform: "translate(-785.842 -215.175)",
    fill: "#8ca6c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21990",
    "data-name": "Path 21990",
    d: "M99.328,449.093l4.729-1.406-4.729-1.406a6.906,6.906,0,0,1-4.651-4.651L93.271,436.9l-1.406,4.729a6.905,6.905,0,0,1-4.651,4.651l-4.729,1.406,4.729,1.406a6.905,6.905,0,0,1,4.651,4.651l1.406,4.729,1.406-4.729a6.906,6.906,0,0,1,4.651-4.651",
    transform: "translate(-70.475 -373.284)",
    fill: "#8ca6c5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGoodJob);
export default __webpack_public_path__ + "static/media/img_good_job.0abd4d0ec48508c12a029dfd6f68ad63.svg";
export { ForwardRef as ReactComponent };